import { render, staticRenderFns } from "./FormElementsPage.vue?vue&type=template&id=084b0780&"
import script from "./FormElementsPage.vue?vue&type=script&lang=js&"
export * from "./FormElementsPage.vue?vue&type=script&lang=js&"
import style0 from "./FormElementsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports